import { render, staticRenderFns } from "./EachDistrictConstructionByLocalElderNumber.vue?vue&type=template&id=be8d3c9a&scoped=true&"
import script from "./EachDistrictConstructionByLocalElderNumber.vue?vue&type=script&lang=js&"
export * from "./EachDistrictConstructionByLocalElderNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8d3c9a",
  null
  
)

export default component.exports